import React, { FC } from "react"

import { Button, Group, Modal, ModalProps, Paper, Select, Stack, Text } from "@mantine/core"
import { IconSwitch } from "@tabler/icons-react"

import { DeviceDocument, useGroups } from "../../../../contexts/devices-context"
import { useLanguage } from "../../../../contexts/language-context"
import useChangeGroup from "./useChangeGroup"

type ChangeGroupModalProps = ModalProps & { device: DeviceDocument }

const ChangeGroupModal: FC<ChangeGroupModalProps> = ({ device, ...props }) => {
    const { L } = useLanguage()
    const { data, map } = useGroups()
    const { form, onSubmit, processing } = useChangeGroup(device, props.onClose)

    return (
        <Modal {...props} title={<Text weight="bold">{L("Change group")}</Text>}>
            <form onSubmit={form.onSubmit(onSubmit)}>
                <Stack>
                    <Text>
                        {L(
                            "You are about to change the group for %s. Please select the target group. Unless specified at device level, the settings of this group will be applied.",
                            <Text weight="bold" span>
                                {device.name}
                            </Text>,
                        )}
                    </Text>
                    {device.group !== device.organisation && (
                        <Paper p="sm" withBorder>
                            <Text size="sm" color="dimmed">
                                Current group
                            </Text>
                            <Text>{map[device.group].name}</Text>
                        </Paper>
                    )}
                    <Select
                        label={L("Target group")}
                        description={L("Select the group to which to add the device.")}
                        data={
                            data
                                .filter(({ id }) => id != device.group )
                                .map(({ id, name }) => ({ value: id, label: name }))
                        }
                        withinPortal
                        {...form.getInputProps("targetGroup")}
                    />
                    <Group position="right" noWrap>
                        <Button variant="subtle" onClick={props.onClose}>
                            {L("Cancel")}
                        </Button>
                        <Button type="submit" variant="filled" leftIcon={<IconSwitch size={16} />} loading={processing}>
                            {L("Change group")}
                        </Button>
                    </Group>
                </Stack>
            </form>
        </Modal>
    )
}

export default ChangeGroupModal
